export { BrandingForm } from './BrandingForm';

// Ory branding
export const boxyhqBranding = {
  logoUrl: '/logo.svg',
  faviconUrl: '/favicon.ico',
  companyName: 'Ory Polis',
  primaryColor: '#4f39f6',
};
